import wasmUrl from "@cap.js/wasm/browser/cap_wasm_bg.wasm?url";

import SolverWorker from "./solver-worker?worker&inline";

function makeWorker() {
	return new SolverWorker();
}

export default async function solveChallenges(
	challenges: Array<[string, string]>,
) {
	const total = challenges.length;
	let completed = 0;

	const workersCount = navigator.hardwareConcurrency || 8;

	const workers = Array(workersCount)
		.fill(null)
		.map(() => {
			try {
				return makeWorker();
			} catch (error) {
				console.error("[cap] Failed to create worker:", error);
				throw new Error("Worker creation failed");
			}
		});

	const solveSingleChallenge = (
		[salt, target]: [string, string],
		workerId: number,
	) => {
		return new Promise<[string, string, string]>((resolve, reject) => {
			const worker = workers[workerId];
			if (!worker) {
				reject(new Error("Worker not available"));
				return;
			}

			const timeout = setTimeout(() => {
				try {
					worker.terminate();
					workers[workerId] = makeWorker();
				} catch (error) {
					console.error(
						"[cap] Error terminating/recreating worker:",
						error,
					);
				}
				reject(new Error("Worker timeout"));
			}, 30_000);

			worker.onmessage = ({ data }) => {
				if (data.error) {
					console.error("[cap] error: ", data.error);
					return;
				}
				clearTimeout(timeout);
				completed++;

				console.log(
					"[cap] progress: ",
					Math.round((completed / total) * 100),
				);
				resolve([salt, target, String(data.nonce)]);
			};

			worker.onerror = (err) => {
				clearTimeout(timeout);
				console.error("[cap] error: ", err);
				reject(err);
			};

			try {
				worker.postMessage({
					salt,
					target,
					wasmUrl: new URL(wasmUrl, import.meta.url).toString(),
				});
			} catch (error) {
				clearTimeout(timeout);
				reject(
					new Error(
						`Failed to send message to worker: ${error.message}`,
					),
				);
			}
		});
	};

	const results = [];
	try {
		for (let i = 0; i < challenges.length; i += workersCount) {
			const chunk = challenges.slice(
				i,
				Math.min(i + workersCount, challenges.length),
			);
			const chunkResults = await Promise.all(
				chunk.map(solveSingleChallenge),
			);
			results.push(...chunkResults);
		}
	} finally {
		workers.forEach((w) => {
			if (w) {
				try {
					w.terminate();
				} catch (error) {
					console.error("[cap] Error terminating worker:", error);
				}
			}
		});
	}

	return results;
}
